module.exports = __webpack_public_path__ + "static/logogrey-1531e88dd2bb3e2628869ff068a4b673.svg";